import React, { ReactElement } from 'react';

import { SafelyExitCourseOverlay } from '../../../ComponentLibrary/organisms/SafelyExitCourseOverlay/SafelyExitCourseOverlay';
import { StudentViewMode } from '../../../config/constants';
import { generalMessages } from '../../../translates/generalMessages';
import { useExitCourse } from '../../hooks/useExitCourse';
import { useSwitch } from '../../hooks/useSwitch';
import { ExitCourseButton } from './atoms/ExitCourseButton';
import { FormattedMessage } from 'react-intl';

import './MenuHeaderActions.scss';

interface MenuHeaderActionsProps {
  isInPreview: boolean;
  hideStudentHeader: boolean;
  configurationButton?: ReactElement;
  viewMode: StudentViewMode;
}

export const MenuHeaderActions: React.FC<MenuHeaderActionsProps> = (props: MenuHeaderActionsProps) => {
  const showScormExitInstructions = useSwitch(false);

  const exitCourse = useExitCourse(props.viewMode, showScormExitInstructions.turnOn, props.hideStudentHeader);

  if (showScormExitInstructions.isOn) {
    return <SafelyExitCourseOverlay />;
  }

  if (!props.configurationButton && !exitCourse) {
    return null;
  }

  return (
    <div className="menu-header__wrapper">
      {!props.isInPreview && exitCourse && (
        <ExitCourseButton title={<FormattedMessage {...generalMessages.exitCourse} />} onClick={exitCourse} />
      )}
      {props.configurationButton}
    </div>
  );
};
